export class IExpertPersonalData {
    name: string;
    lastname: string;
    // Extra properties
    [key: string]: any; // Se agregó porque en el componente ExpertProfilePublicInfoPageComponent estaba marcando error por una propiedad
}
